import React from "react"
import { NumberProperty } from "../../@types/EpiFoundationSpa/Property"
import { Flex, INNER_MAX_WIDTH } from "@capioweb/ui-components/src"

type GhpReferralBlockProps = {
	clinicId: NumberProperty
}

const GhpReferralBlock: React.FC = (props: GhpReferralBlockProps) => {
	const id = "ghp-referral"
	React.useEffect(() => {
		const script = document.createElement("script")
		script.src = "https://muntra-dev.github.io/referral-page/index.js"
		script.id = "muntra-referral-widget"
		script.async = true
		script.type = "text/javascript"

		document.getElementById(id).appendChild(script)

		return () => {
			document
				.getElementById(props.clinicId.value.toString())
				.removeChild(script)
		}
	}, [])
	let muntra_clinic_id = { muntra_clinic_id: props.clinicId.value }

	return (
		<Flex
			as="section"
			id={id}
			display="block"
			px={3}
			pt={4}
			alignItems="center"
			flexDirection="column"
			w={1}
			maxw={INNER_MAX_WIDTH}
			style={{ margin: "0 auto" }}
		>
			<div className="muntra-referral-widget" {...muntra_clinic_id} />
		</Flex>
	)
}
export { GhpReferralBlock }
